import createAxios from './api'

const PATH = 'userGroups'
export default {
  async createUserGroup(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}`, req)
  },
  async updateUserGroup(id, req) {
    const axios = await createAxios()
    const resp = await axios.put(`${PATH}/${id}`, req)
  },
  async listUserGroups(q, req) {
    const axios = await createAxios()

    const resp = await axios.get(`${PATH}`, {
      params: {
        q,
        ...req
      }
    })

    return resp.data
  },
  async getUserGroup(id) {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/${id}`)
    return resp.data
  },
  async deleteUserGroup(id) {
    const axios = await createAxios()
    await axios.delete(`${PATH}/${id}`)
  }
}
